(function () {
    const labels = window.toImpressBssTranslations;
    const bss = window.BSS_B2B;
    if (!labels || !bss || document.documentElement.lang.toLowerCase().split('-')[0] !== 'nl') return;
    for (const [moduleKey, dictionary] of Object.entries(labels)) {
        bss[moduleKey] = Object.assign({}, bss[moduleKey] || {}, dictionary);
    }
})();

document.addEventListener("DOMContentLoaded", function () {
    if(window.location.pathname.includes("product")) {
        const interval = setInterval(() => {
            const rows = document.querySelectorAll(".bss-b2b-qty-table-row");

            if (rows.length >= 4) {
                rows[3].click();
                clearInterval(interval);
            }
        }, 300); 
        setTimeout(() => {
            clearInterval(interval);
        }, 8000);
    }
});
